import React, { useState, useRef, useEffect } from 'react'

import Image from '../../common/Image/Image'
import styles from './PictureDescription.module.css'
import cx from '../../../utils/className'
import { withPlugin } from '@flamingo_tech/funkgo'
import Pressable from '../../common/Pressable/Pressable'

const PictureDescription = props => {
  const isDesktop = props.$detector.isDesktop()
  const [expanded, setExpanded] = useState(true)
  const imgRef = useRef()


  useEffect(() => {
    const { height } = (imgRef && imgRef.current && imgRef.current.getBoundingClientRect()) || {}
    if (!isDesktop && height) {
      setExpanded(height < 800)
    }
  }, [isDesktop])

  if (!props.graphicDescription || props.graphicDescription.length <= 0) {
    return null
  }

  const inner = (
    <>
      {
        !expanded && (
          <div className={styles.cover}>
            {props.$i18n.transl('common.viewMore')}
            <span className={styles.icon} aria-hidden="true">&#xe7b2;</span>
          </div>
        )
      }
      {
        props.graphicDescription.map((pic, index) => {
          return (
            <div key={index}>
              <Image
                src={pic.imageUrl}
                placeholder={{ width: pic.width, height: pic.height }}
                original
                lazy
                title={pic.title || pic.alt || props.$i18n.transl('common.viewMore')}
              />
            </div>
          )
        })
      }
    </>
  )

  if (expanded) {
    return (
      <div className={cx(styles.wrapper, styles.expanded)} ref={imgRef}>
        {inner}
      </div>
    )
  }

  return (
    <Pressable className={styles.wrapper} onClick={() => setExpanded(true)} ref={imgRef} ariaLabel={props.$i18n.transl('common.viewMore')}>
      {inner}
    </Pressable>
  )
}

export default withPlugin(PictureDescription)
